import {http, onSuccess, onSuccessWithHeaders, onFail} from './http';

export const exchangeKey = (watchKey) =>
    http.get(`/api/player/exchangeKey/${watchKey}`)
        .then(onSuccess, onFail);

export const exchangeKeyWithHeaders = (watchKey) =>
    http.get(`/api/player/exchangeKey/${watchKey}`)
        .then(onSuccessWithHeaders, onFail);

export const kasperskyIp = () =>
    http.get(`//kickoffvideo.kaspersky.com/ip`, {timeout: 2000})
        .then(onSuccess, onFail);

export const eventGet = async (eventKey, params) =>
    http.get(`/api/player/event/${eventKey}`, {params})
        .then(onSuccess, onFail);

export const getUserBalance = async (eventKey) =>
    http.get(`/api/player/event/${eventKey}/balance`)
        .then(onSuccess, onFail);

export const getUserBalanceHistory = async (eventKey) =>
    http.get(`/api/player/event/${eventKey}/balance/history`)
        .then(onSuccess, onFail);
